import type { GoogleAuthResponse, RegisterResponse } from "@/types/api";
import { clearSession, refreshTokenBody } from "@/auth/nativeSession";
import client from "./client";

export async function register(data: {
  email: string;
  password: string;
  handle: string;
  birthdate: string;
}): Promise<RegisterResponse> {
  const res = await client.post<RegisterResponse>("/auth/register", data);
  return res.data;
}

export async function login(data: { email: string; password: string }): Promise<void> {
  await client.post("/auth/login", data);
}

export async function verifyEmail(token: string): Promise<void> {
  await client.post("/auth/verify", { token });
}

export async function confirmEmailChange(token: string): Promise<void> {
  await client.post("/auth/confirm-email-change", { token });
}

export async function forgotPassword(data: { email: string }): Promise<{ message: string }> {
  const res = await client.post<{ message: string }>("/auth/forgot-password", data);
  return res.data;
}

export async function resetPassword(data: { token: string; password: string }): Promise<void> {
  await client.post("/auth/reset-password", data);
}

export async function logoutApi(): Promise<void> {
  try {
    await client.post("/auth/logout", await refreshTokenBody());
  } finally {
    await clearSession();
  }
}

export async function googleSignIn(idToken: string): Promise<GoogleAuthResponse> {
  const res = await client.post<GoogleAuthResponse>("/auth/google", { id_token: idToken });
  return res.data;
}

export async function googleComplete(data: {
  signup_token: string;
  handle: string;
  birthdate: string;
  bio?: string | null;
  climbing_since?: number | null;
  instagram_url?: string | null;
  strava_url?: string | null;
  youtube_url?: string | null;
  tiktok_url?: string | null;
}): Promise<void> {
  await client.post("/auth/google/complete", data);
}

export async function googleLink(data: { link_token: string; password: string }): Promise<void> {
  await client.post("/auth/google/link", data);
}
